import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { Error as ErrorIcon } from '@mui/icons-material';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('🚨 Error caught by boundary:', error);
    console.error('Component stack:', errorInfo);
    this.setState({
      error: error.toString(),
      errorInfo: errorInfo.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            backgroundColor: '#0a0e27',
            padding: 3,
          }}
        >
          <Paper
            sx={{
              padding: 4,
              maxWidth: 600,
              backgroundColor: '#1a1d3a',
              border: '1px solid #ff6f00',
            }}
          >
            <Box display="flex" alignItems="center" mb={2}>
              <ErrorIcon sx={{ fontSize: 48, color: 'error.main', mr: 2 }} />
              <Typography variant="h5" color="error.main">
                Error in Admin Panel
              </Typography>
            </Box>
            <Typography variant="body1" color="text.primary" paragraph>
              An error occurred while loading the admin panel. Please check the browser console for details.
            </Typography>
            <Paper
              sx={{
                padding: 2,
                backgroundColor: '#000000',
                overflow: 'auto',
                maxHeight: 300,
                marginBottom: 2,
              }}
            >
              <Typography
                variant="caption"
                component="pre"
                sx={{ color: '#ff6f00', fontFamily: 'monospace', fontSize: '0.75rem' }}
              >
                {this.state.error}
              </Typography>
            </Paper>
            <Button
              variant="contained"
              color="primary"
              onClick={() => window.location.reload()}
              fullWidth
            >
              Reload Page
            </Button>
          </Paper>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
